// extracted by mini-css-extract-plugin
export var completionBody = "_lq-2";
export var completionCard = "_lq-0";
export var completionFooter = "_lq-3";
export var completionTitle = "_lq-1";